"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxColumn = void 0;
const _ = __importStar(require("lodash"));
const slickgrid_1 = require("slickgrid");
const DEFAULTS = {
    id: '_checkbox_selector',
    name: '',
    field: '$selected',
    toolTip: '',
    cssClass: '',
    width: 30,
    rowSelector: true,
    frozen: true,
    systemColumn: true,
    filterable: false,
    resizable: false,
    sortable: false,
    hideable: false,
    headerSelect: true,
    readOnly: false
};
class CheckboxColumn {
    pluginName = 'CheckboxColumn';
    eventHandler;
    grid;
    selectedRows;
    id;
    name;
    field;
    rowSelector;
    headerCssClass;
    maxWidth;
    minWidth;
    rerenderOnResize;
    resizable;
    selectable;
    sortable;
    hideable;
    toolTip;
    width;
    onSelectionChanged;
    constructor(options) {
        this.eventHandler = new slickgrid_1.SlickEventHandler();
        this.selectedRows = {};
        _.extend(this, this.getColumnOptions({ ...DEFAULTS, ...options }));
    }
    init(grid) {
        this.grid = grid;
        if (this.rowSelector) {
            const rowSelection = new slickgrid_1.SlickRowSelectionModel({
                selectActiveRow: false
            });
            grid.registerPlugin(rowSelection);
            grid.setSelectionModel(rowSelection);
            this.eventHandler.subscribe(grid.onSelectedRowsChanged, this.onSelectedRowsChanged.bind(this));
        }
        this.eventHandler
            .subscribe(grid.onClick, this.onClick.bind(this))
            .subscribe(grid.onHeaderClick, this.onHeaderClick.bind(this))
            .subscribe(grid.onKeyDown, this.onKeyDown.bind(this));
    }
    destroy() {
        this.eventHandler.unsubscribeAll();
    }
    onSelectedRowsChanged(e, args) {
        const grid = args.grid, selection = grid.getSelectedRows();
        this.updateColumnHeader(selection.length === grid.getDataLength());
    }
    updateColumnHeader(checked) {
        const extras = checked ? ' checked="checked"' : '';
        this.grid.updateColumnHeader(this.id, `<input type="checkbox"${extras}>`, this.toolTip);
    }
    onClick(e, args) {
        if (e.target.type !== 'checkbox') {
            return;
        }
        if (!this.isThisColumn(args.cell)) {
            return;
        }
        if (args.grid.getEditorLock().isActive(null) &&
            !args.grid.getEditorLock().commitCurrentEdit()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
        }
        this.toggleRowSelection(args.row);
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
    onHeaderClick(e, args) {
        if (e.target.type !== 'checkbox') {
            return;
        }
        if (args.column.id !== this.id) {
            return;
        }
        if (args.grid.getEditorLock().isActive(null) &&
            !args.grid.getEditorLock().commitCurrentEdit()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
        }
        const selected = e.target.checked, field = this.field, selectedRows = [];
        for (let i = 0; i < args.grid.getDataLength(); i++) {
            let data = this.grid.getDataItem(i);
            if (data[field] !== selected) {
                data[field] = selected;
            }
            if (selected) {
                selectedRows.push(i);
            }
        }
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.grid.setSelectedRows(selectedRows);
        this.grid.invalidateAllRows();
        this.grid.render();
    }
    onKeyDown(e, args) {
        if (e.which === 32 && this.isThisColumn(args.cell)) {
            if (!args.grid.getEditorLock().isActive(null) ||
                args.grid.getEditorLock().commitCurrentEdit()) {
                this.toggleRowSelection(args.row);
            }
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    }
    getColumnOptions(options) {
        const result = { ...options };
        if (options.headerSelect) {
            result.name = result.name
                ? `<label><input type="checkbox"> ${result.name}</label>`
                : '<input type="checkbox">';
        }
        if (options.toolTip) {
            result.toolTip = 'Select/Deselect All';
        }
        result.formatter = getFormatter(options);
        return result;
    }
    toggleRowSelection(row) {
        const data = this.grid.getDataItem(row), selected = !data[this.field];
        data[this.field] = selected;
        if (this.rowSelector) {
            let selectedRows = this.grid.getSelectedRows();
            this.grid.setSelectedRows(selected ? selectedRows.concat(row) : _.without(selectedRows, row));
        }
        else {
            this.grid.invalidateRow(row);
            this.grid.render();
            this.emitSelectionChanged({ row, data });
        }
    }
    isThisColumn(cell) {
        const column = this.grid.getColumns()[cell];
        return column && column.id === this.id;
    }
    emitSelectionChanged(args) {
        if (this.onSelectionChanged) {
            this.onSelectionChanged(args);
        }
    }
}
exports.CheckboxColumn = CheckboxColumn;
function getFormatter(options) {
    const extras = options.readOnly
        ? ' tabindex="-1" style="pointer-events: none"'
        : '', tpl_truthy = '<input type="checkbox" checked="checked">', tpl_falsy = `<input type="checkbox" ${extras}>`;
    return function checkboxFormatter(row, cell, value, columnDef, data) {
        return data ? (value ? tpl_truthy : tpl_falsy) : null;
    };
}
//# sourceMappingURL=CheckboxColumn.js.map